/* Ecochic · PDF de ingrediente y set de la rutina (FLUJO §7, reglas 15-18), portado de web-v3/js/views/ingredientes.js.
   Datos y textos: script#eco-ing-full (snippet eco-ing-full-data, textos en Configuración del tema). Se genera en el navegador. */
(function () {
  'use strict';
  function data() { try { return JSON.parse(document.getElementById('eco-ing-full').textContent); } catch (e) { return { labels: {}, items: [] }; } }
  function na(s) { return String(s == null ? '' : s).toLowerCase(); }
  function hasActive(p, slug) { return (p.tags || []).some(function (t) { return na(t).replace(/\s+/g, '') === 'activo:' + slug; }); }
  function productCount(slug) { return (window.PRODUCTS || []).filter(function (p) { return !(window.ECO_DATA && ECO_DATA.isService(p.h)) && hasActive(p, slug); }).length; }
  // C377: chips con el nombre de eco_chip_names; sin nombre (p. ej. «dermatitis»), fuera
  function named(vals, D) {
    var M = D.chip_names || {}, out = [];
    (vals || []).forEach(function (v) { var n = M[String(v == null ? '' : v).trim().toLowerCase()]; if (n && out.indexOf(n) < 0) out.push(n); });
    return out;
  }
  function refObj(line) {
    var url = '', cita = line;
    var m = /(https?:\/\/\S+)/.exec(line);
    if (m) { url = m[1]; cita = line.replace(m[1], '').replace(/[\s|·-]+$/, '').trim(); }
    else { var d = /doi:\s*(\S+)/i.exec(line); if (d) url = 'https://doi.org/' + d[1]; }
    return { cita: cita || url, url: url };
  }
  function caption(ing, L) {
    if (ing.tipo === 'planta') return (L.plant_caption || '').replace('[atribucion]', ing.atribucion || '').replace('[url]', ing.fuente_url || '').replace(/\s·\s*$/, '');
    if (ing.tipo === 'molecula') return (L.mol_caption || '').replace('[compuesto]', ing.compuesto || ing.nombre || '').replace('[cid]', ing.cid || '');
    return ing.atribucion || '';
  }
  function measured(url) {
    if (!(window.EcoPDF && EcoPDF.imageToDataURL) || !url) return Promise.resolve({ dataURL: null, ratio: 1 });
    return EcoPDF.imageToDataURL(url).then(function (d) {
      if (!d) return { dataURL: null, ratio: 1 };
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res({ dataURL: d, ratio: (im.naturalHeight || 1) / (im.naturalWidth || 1) }); }; im.onerror = function () { res({ dataURL: d, ratio: 1 }); }; im.src = d; });
    }).catch(function () { return { dataURL: null, ratio: 1 }; });
  }
  function ficha(slug) {
    var D = data(), L = D.labels, ing = D.items.filter(function (i) { return i.slug === slug; })[0];
    if (!ing || !(window.EcoPDF && EcoPDF.create)) return Promise.reject(new Error('PDF no disponible'));
    return measured(ing.img).then(function (mi) {
      return EcoPDF.create({ title: ing.nombre, subtitle: ing.inci ? (L.inci + ' · ' + ing.inci) : '', eyebrow: L.eyebrow }).then(function (doc) {
        doc.kv(L.familia, ing.familia || L.review);
        var n = productCount(ing.slug); doc.kv(L.catalogo, n + ' ' + (n === 1 ? L.producto : L.productos));
        doc.spacer(2);
        var w = 200, h = mi.dataURL ? Math.max(120, Math.min(240, Math.round(w * (mi.ratio || 1)))) : 0;
        if (mi.dataURL) doc.image(mi.dataURL, { w: w, h: h, caption: caption(ing, L) }); else doc.placeholder(L.no_image);
        doc.spacer(2);
        doc.heading(L.que_es); doc.paragraph(ing.que_es || L.review);
        doc.heading(L.que_hace); doc.paragraph(ing.que_hace || L.review);
        var piel = named(ing.para_piel, D), dol = named(ing.dolencias, D);
        doc.chips(L.piel, piel.length ? piel : [L.review]);
        doc.chips(L.dolencias, dol.length ? dol : [L.review]);
        if (ing.nota) { doc.heading(L.nota); doc.paragraph(ing.nota); }
        doc.heading(L.refs); doc.note(L.refs_note); doc.refs(ing.referencias.map(refObj));
        doc.note(L.final_note);
        doc.save('ecochic-ingrediente-' + ing.slug + '.pdf');
        return true;
      });
    });
  }
  function set(slugs, title) {
    var D = data(), L = D.labels;
    var list = (slugs || []).map(function (s) { return D.items.filter(function (i) { return i.slug === s; })[0]; }).filter(Boolean);
    if (!list.length || !(window.EcoPDF && EcoPDF.create)) return Promise.reject(new Error('Sin ingredientes'));
    return Promise.all(list.map(function (ing) { return measured(ing.img).then(function (mi) { return { ing: ing, mi: mi }; }); })).then(function (rows) {
      return EcoPDF.create({ title: title, subtitle: (L.set_subtitle || '').replace('[n]', list.length), eyebrow: L.set_eyebrow }).then(function (doc) {
        rows.forEach(function (row, idx) {
          var ing = row.ing, mi = row.mi;
          if (idx > 0) doc.pageBreak();
          doc.heading(ing.nombre);
          if (ing.inci) doc.kv(L.inci, ing.inci);
          doc.kv(L.familia, ing.familia || L.review);
          var w = 160, h = mi.dataURL ? Math.max(100, Math.min(200, Math.round(w * (mi.ratio || 1)))) : 0;
          if (mi.dataURL) doc.image(mi.dataURL, { w: w, h: h, caption: caption(ing, L) }); else doc.placeholder(L.no_image_set);
          doc.h2(L.que_es); doc.paragraph(ing.que_es || L.review);
          doc.h2(L.que_hace); doc.paragraph(ing.que_hace || L.review);
          var piel = named(ing.para_piel, D);
          doc.chips(L.piel, piel.length ? piel : [L.review]);
          doc.h2(L.refs); doc.refs(ing.referencias.map(refObj));
        });
        doc.note(L.set_note);
        doc.save('ecochic-set-ingredientes.pdf');
        return true;
      });
    });
  }
  // Regla 17: «Generando…» → «Descargada» / «No se pudo generar», y a los 1,4 s vuelve el texto
  function run(btn, fn) {
    if (!btn || btn.disabled) return;
    var L = data().labels, orig = btn.textContent;
    btn.disabled = true; btn.textContent = L.generating;
    Promise.resolve().then(fn).then(function () { btn.textContent = L.done; }, function (e) { try { console.error('Ecochic PDF:', e); } catch (_) {} btn.textContent = L.error; })
      .then(function () { setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1400); });
  }
  window.EcoIngPDF = { ficha: ficha, set: set, run: run };
})();
